var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 28,
    viewBox: "0 0 19 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56978 1.26067C8.83249 1.09066 9.14061 1 9.45571 1C9.7708 1 10.0789 1.09066 10.3416 1.26067L18 5.10821V19.4884H11.9855L8.23509 25V20.6908L10.6862 17.1029H15.608V6.57989L9.50493 3.50186L3.40186 6.57989V17.1029H8.32369V19.4884H1V5.12744L8.56978 1.26067Z",
    fill: "#AAACAB",
    stroke: "#AAACAB",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c0fc3ed98d15c0c22325f9031796eb85.svg";
export { ForwardRef as ReactComponent };